import { z } from 'zod';

export const CallType = z.enum([
  'bundle',
  'connectMe',
  'brandedCall',
  'typpromonumber',
]);

export type CallType = z.infer<typeof CallType>;
